import { useEffect, useState } from 'react';

import { Device, Store } from '@/classes';
import { useRouter } from '@/hooks/useRouter';

export const useDeepLink = () => {
  const router = useRouter();
  const [prevRedirect, setPrevRedirect] = useState<string>('');

  useEffect(() => {
    if (!router) return;

    const redirectTo = (redirect?: string) => {
      if (!redirect || redirect === prevRedirect) return;

      router.push(redirect);
      setPrevRedirect(redirect);
      Store.set('histories', [{ pathname: '/home', query: {} }]);
    };

    const tizen = (window as any).tizen;

    if (tizen) {
      const deepLink = () => {
        try {
          const requestedAppControl = tizen.application.getCurrentApplication().getRequestedAppControl();

          if (!requestedAppControl) {
            console.info('no req app control');
            return;
          }

          const appControlData = requestedAppControl.appControl.data;
          let actionData;
          let redirect;

          for (let i = 0; i < appControlData.length; i++) {
            if (appControlData[i].key == 'PAYLOAD') {
              actionData = JSON.parse(appControlData[i].value[0]).values;
              redirect = JSON.parse(actionData).redirect;
            }
          }

          redirectTo(redirect);
        } catch (e) {
          console.error('Tizen DeepLink error', e);
        }
      };

      // ! Tizen Public Preview Document
      // https://developer.samsung.com/smarttv/develop/guides/smart-hub-preview/implementing-public-preview.html#:~:text=HTTP%20%ED%97%A4%EB%8D%94%20%ED%95%84%EB%93%9C-,%EA%B3%B5%EA%B0%9C%20%EB%AF%B8%EB%A6%AC%EB%B3%B4%EA%B8%B0%20%EB%94%A5%20%EB%A7%81%ED%81%AC%20%EA%B5%AC%ED%98%84,-%ED%83%80%EC%9D%BC%EC%9D%84%20%ED%81%B4%EB%A6%AD%ED%95%98%EB%A9%B4%20%EC%97%B0%EA%B4%80%EB%90%9C
      window.addEventListener('appcontrol', deepLink);
      deepLink();

      return () => window.removeEventListener('appcontrol', deepLink);
    }

    if (Device.isWebOS) {
      const deepLink = () => {
        const webOSSystem = (window as any)?.webOSSystem;
        const palmSystem = (window as any)?.PalmSystem;
        const launchParams = webOSSystem?.launchParams || palmSystem?.launchParams || '';

        if (!launchParams) return;

        try {
          redirectTo(JSON.parse(launchParams)?.contentTarget);
        } catch (e) {
          console.error(e);
        }
      };

      document.addEventListener('webOSRelaunch', deepLink);
      deepLink();

      return () => document.removeEventListener('webOSRelaunch', deepLink);
    }
  }, [prevRedirect, router]);
};
